module.exports = __webpack_public_path__ + "static/contentselection-backgroundregion-do-a4d89bba46151ea8e8c904aa2596cd86.png";